import { useQuery } from "@tanstack/react-query";
import { propertySelectionApi } from "libs/api";
import { useParams } from "router";
import { TanstackQueryKey } from "../commons/tanstackQueryKey";
import { useUnfinishedPropertiesState } from "./unfinishedPropertiesAtom";

export const useUnfinishedPropertiesApi = () => {
    const { lang } = useParams("/:lang/list-my-property");
    const [value, setValue] = useUnfinishedPropertiesState();

    const { isLoading, isError } = useQuery({
        queryKey: [TanstackQueryKey.GetUnfinishedProperties],
        queryFn: () => propertySelectionApi.getUnfinishedProperties(lang).then((res) => res.data),
        onSuccess: setValue,
    });

    return {
        isLoading: isLoading || value === undefined,
        isError,
    };
};
